import DepositorsService from '../../services/DepositorsService';
import swal from "sweetalert";

// Action Types
export const LOADING_TOGGLE_ACTION = '[Depositors] Loading Toggle';
export const GET_DEPOSITORS_SUCCESS = '[Depositors] Get Depositors Success';
export const GET_DEPOSITORS_FAILED = '[Depositors] Get Depositors Failed';
export const GET_DEPOSITOR_BY_ID_SUCCESS = '[Depositors] Get Depositor By ID Success';
export const GET_DEPOSITOR_BY_ID_FAILED = '[Depositors] Get Depositor By ID Failed';
export const CREATE_DEPOSITOR_SUCCESS = '[Depositors] Create Depositor Success';
export const CREATE_DEPOSITOR_FAILED = '[Depositors] Create Depositor Failed';
export const UPDATE_DEPOSITOR_SUCCESS = '[Depositors] Update Depositor Success';
export const UPDATE_DEPOSITOR_FAILED = '[Depositors] Update Depositor Failed';
export const CLOSE_DEPOSITOR_SUCCESS = '[Depositors] Close Depositor Success';
export const CLOSE_DEPOSITOR_FAILED = '[Depositors] Close Depositor Failed';
export const GET_DEPOSITOR_KYC_SUCCESS = '[Depositors] Get Depositor KYC Success';
export const GET_DEPOSITOR_KYC_FAILED = '[Depositors] Get Depositor KYC Failed';
export const SUBMIT_KYC_DOCUMENT_SUCCESS = '[Depositors] Submit KYC Document Success';
export const SUBMIT_KYC_DOCUMENT_FAILED = '[Depositors] Submit KYC Document Failed';
export const REFRESH_STATUS_SUCCESS = '[Depositors] Refresh Status Success';
export const REFRESH_STATUS_FAILED = '[Depositors] Refresh Status Failed';
export const BULK_REFRESH_SUCCESS = '[Depositors] Bulk Refresh Success';
export const BULK_REFRESH_FAILED = '[Depositors] Bulk Refresh Failed';
export const GET_DEPOSIT_HISTORY_SUCCESS = '[Depositors] Get Deposit History Success';
export const GET_DEPOSIT_HISTORY_FAILED = '[Depositors] Get Deposit History Failed';
export const CLEAR_CURRENT_DEPOSITOR = '[Depositors] Clear Current Depositor';
export const CLEAR_ERRORS = '[Depositors] Clear Errors';
export const SET_CURRENT_PAGE = '[Depositors] Set Current Page';
export const SET_FILTERS = '[Depositors] Set Filters';
export const RESET_DEPOSITOR_SUCCESS = '[Depositors] Reset Success State';

// Action Creators
export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export function getDepositorsAction(params = {}) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await DepositorsService.getDepositors(params);
            console.log('getDepositorsAction',response)
            dispatch({
                type: GET_DEPOSITORS_SUCCESS,
                payload: response
            });
        } catch (error) {
            console.log('error', error)
            dispatch({
                type: GET_DEPOSITORS_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch depositors'
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getDepositorByIdAction(id) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await DepositorsService.getDepositorById(id);
            dispatch({
                type: GET_DEPOSITOR_BY_ID_SUCCESS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITOR_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch depositor'
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function createDepositorAction(depositorData, navigate) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await DepositorsService.createDepositor(depositorData);
            console.log('Full response:', response);
            console.log('response.success:', response.success);
            
            if (response && response.success === true) {
                dispatch({
                    type: CREATE_DEPOSITOR_SUCCESS,
                    payload: response.data
                });
                swal({
                    title: "Success!",
                    text: response.message || "Depositor created successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositorSuccess());
                    if (navigate) {
                        navigate('/depositors');
                    }
                });
            } else {
               alert('error')
                console.log('Success is false, showing error');
                dispatch({
                    type: CREATE_DEPOSITOR_FAILED,
                    payload: response.message || 'Failed to create depositor'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to create depositor",
                    icon: "error",
                    buttons: true
                });
            }
        } catch (error) {
            alert('catch')
            const errorMessage = error.response?.data?.message || 'Failed to create depositor';
            dispatch({
                type: CREATE_DEPOSITOR_FAILED,
                payload: errorMessage
            });
            swal({
                title: "Error!",
                text: errorMessage,
                icon: "error",
                buttons: true
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function updateDepositorAction(id, depositorData, navigate) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await DepositorsService.updateDepositor(id, depositorData);
            if (response.success) {
                dispatch({
                    type: UPDATE_DEPOSITOR_SUCCESS,
                    payload: response.data
                });
                swal({
                    title: "Success!",
                    text: response.message || "Depositor updated successfully",
                    icon: "success",
                    timer: 2000,
                    buttons: false
                }).then(() => {
                    dispatch(resetDepositorSuccess());
                    if (navigate) {
                        navigate('/depositors');
                    }
                });
            } else {
                dispatch({
                    type: UPDATE_DEPOSITOR_FAILED,
                    payload: response.message
                });
                swal("Error!", response.message || "Failed to update depositor", "error");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to update depositor';
            dispatch({
                type: UPDATE_DEPOSITOR_FAILED,
                payload: errorMessage
            });
            swal("Error!", errorMessage, "error");
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function closeDepositorAction(id) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await DepositorsService.closeDepositor(id);
            if (response.success) {
                dispatch({
                    type: CLOSE_DEPOSITOR_SUCCESS,
                    payload: { id, ...response.data }
                });
                swal({
                    title: "Success!",
                    text: response.message || "Depositor closed successfully",
                    icon: "success",
                    timer: 2000,
                    buttons: false
                }).then(() => {
                    dispatch(resetDepositorSuccess());
                });
            } else {
                dispatch({
                    type: CLOSE_DEPOSITOR_FAILED,
                    payload: response.message
                });
                swal("Error!", response.message || "Failed to close depositor", "error");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to close depositor';
            dispatch({
                type: CLOSE_DEPOSITOR_FAILED,
                payload: errorMessage
            });
            swal("Error!", errorMessage, "error");
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getDepositorKycAction(id) {
    return async (dispatch) => {
        try {
            const response = await DepositorsService.getDepositorKyc(id);
            dispatch({
                type: GET_DEPOSITOR_KYC_SUCCESS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITOR_KYC_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch KYC data'
            });
        }
    };
}

export function submitKycDocumentAction(depositorId, kycSubmissionData, isFileUpload = false) {
    return async (dispatch) => {
        try {
            const response = await DepositorsService.submitKycDocument(depositorId, kycSubmissionData, isFileUpload);
            if (response.success) {
                dispatch({
                    type: SUBMIT_KYC_DOCUMENT_SUCCESS,
                    payload: { 
                        depositorId, 
                        submission: response.data.submission,
                        kycStatus: response.data.kycStatus
                    }
                });
                swal({
                    title: "Success!",
                    text: response.message || "KYC document submitted successfully",
                    icon: "success",
                    timer: 2000,
                    buttons: false
                }).then(() => {
                    dispatch(resetDepositorSuccess());
                });
            } else {
                dispatch({
                    type: SUBMIT_KYC_DOCUMENT_FAILED,
                    payload: response.message
                });
                swal("Error!", response.message || "Failed to submit KYC document", "error");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to submit KYC document';
            dispatch({
                type: SUBMIT_KYC_DOCUMENT_FAILED,
                payload: errorMessage
            });
            swal("Error!", errorMessage, "error");
        }
    };
}

export function refreshDepositorStatusAction(id) {
    return async (dispatch) => {
        try {
            const response = await DepositorsService.refreshDepositorStatus(id);
            if (response.success) {
                dispatch({
                    type: REFRESH_STATUS_SUCCESS,
                    payload: { id, ...response.data }
                });
                swal({
                    title: "Success!",
                    text: response.message || "Status refreshed successfully",
                    icon: "success",
                    timer: 2000,
                    buttons: false
                }).then(() => {
                    dispatch(resetDepositorSuccess());
                });
            } else {
                dispatch({
                    type: REFRESH_STATUS_FAILED,
                    payload: response.message
                });
                swal("Error!", response.message || "Failed to refresh status", "error");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to refresh status';
            dispatch({
                type: REFRESH_STATUS_FAILED,
                payload: errorMessage
            });
            swal("Error!", errorMessage, "error");
        }
    };
}

export function bulkRefreshStatusAction() {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await DepositorsService.bulkRefreshStatuses();
            if (response.success) {
                dispatch({
                    type: BULK_REFRESH_SUCCESS,
                    payload: response.data
                });
                swal({
                    title: "Success!",
                    text: response.message || "Bulk status refresh completed successfully",
                    icon: "success",
                    timer: 2000,
                    buttons: false
                }).then(() => {
                    dispatch(resetDepositorSuccess());
                });
            } else {
                dispatch({
                    type: BULK_REFRESH_FAILED,
                    payload: response.message
                });
                swal("Error!", response.message || "Failed to bulk refresh statuses", "error");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to bulk refresh statuses';
            dispatch({
                type: BULK_REFRESH_FAILED,
                payload: errorMessage
            });
            swal("Error!", errorMessage, "error");
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getDepositHistoryAction(id, params = {}) {
    return async (dispatch) => {
        try {
            const response = await DepositorsService.getDepositHistory(id, params);
            dispatch({
                type: GET_DEPOSIT_HISTORY_SUCCESS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_HISTORY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit history'
            });
        }
    };
}

export function clearCurrentDepositor() {
    return {
        type: CLEAR_CURRENT_DEPOSITOR
    };
}

export function clearErrors() {
    return {
        type: CLEAR_ERRORS
    };
}

export function setCurrentPage(page) {
    return {
        type: SET_CURRENT_PAGE,
        payload: page
    };
}

export function setFilters(filters) {
    return {
        type: SET_FILTERS,
        payload: filters
    };
}

export function resetDepositorSuccess() {
    return {
        type: RESET_DEPOSITOR_SUCCESS
    };
}